import React from 'react';
import EYCard from 'eymp-uicomps/components/Card';
import GlobalProgressBar from '../ProgressBar';
import GlobalChip from '../Chip';
import './CaseCard.scss';
import { formatDate } from 'src/helpers/date';
import { renderCountryFlag } from 'src/helpers/countryFlagEvent';
import intl from 'react-intl-universal';
import { connect } from 'react-redux';

export class CaseCard extends React.Component {
  render() {
    const { id, data, handleClickOnCase } = this.props;
    return (
      <div
        id={'div_' + data.caseId}
        className={`newCard ${data.setCardActive ? 'child-parent' : ''}`}
        onClick={() => handleClickOnCase(id, data, this.props.newDashboard)}>
        <EYCard variant="outlined">
          <GlobalChip data={data} />

          <div className="immi-type ">{`${data.serviceName} -  ${data.isChildCase ? data.dependantFullName : data.employeeFullName}`}</div>
          <div className="card-style ">
            <div className="ssn-number ">{data.ticketNumber + ' | '}</div>
            <div className="country-css card-style">
              <div className="flag">{renderCountryFlag(data.caseCountryCode, data.caseCountry)}</div>
              <div>{data.caseCountry}</div>
            </div>
          </div>
          <GlobalProgressBar progress={data.progress} />
          <div className="card-style">
            {data.targetDate ? (
              <div className="target-date" style={{ flex: 'none' }}>
                {intl.get('newDashboard.caseCard.targetDate') + ': ' + formatDate(data.targetDate)}
              </div>
            ) : null}
            {data.isChildCase ? (
              <div className="card-style name-style">
                <div className="target-date name-style"> {data.employeeFullName} </div>
                <div className="contact-card"></div>
              </div>
            ) : null}
          </div>
        </EYCard>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    state: state,
    newDashboard: state.newDashboard,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CaseCard);
